import {
  getTokenDecimals,
  formatTokenWei,
} from '@blockcatio/tabby-library/lib/utilities/tokenUtilities';

import { stringifyCode } from '../utilities/codeParser';
import { getAppUrl } from './app';
import { getTokenListByName, getTokenSymbolForAddress, getTokenLabelForAddress } from './token';

export const generateUrl = (state, code) =>
  `${getAppUrl(state)}/redeem/${encodeURIComponent(code)}`;

export const getRewardsForRedemption = (state) => {
  const {
    createCampaign: { id, rewards },
  } = state;
  return rewards.map((reward, i) => [
    i + 1,
    generateUrl(state, stringifyCode({ campaignId: id, number: i + 1, code: reward })),
  ]);
};

/**
 * Gets the campaign details state
 * Optional TODO, hand-pick the fields rather than ...state
 */
export const getCampaignDetails = (state) => {
  const tokenList = getTokenListByName(state);
  const { tokensPerCode, totalTokens, tokenAddress } = state.createCampaign;
  const decimals = getTokenDecimals(tokenList, tokenAddress);
  return {
    ...state.createCampaign,
    tokenSymbol: getTokenSymbolForAddress(state, tokenAddress),
    tokenLabel: getTokenLabelForAddress(state, tokenAddress),
    formattedTokensPerCode: formatTokenWei(tokensPerCode, decimals),
    formattedTotalTokens: formatTokenWei(totalTokens, decimals),
  };
};



// WEBPACK FOOTER //
// ./src/selectors/createCampaign.js